import { createDummyTask, removeDummyTask } from './envops';

export default {
  createDummyTask,
  removeDummyTask
};
